(function () {
  function initFaqAccordion() {
    var source = document.querySelector('[data-tdb-faq-source]');
    var accordion = document.querySelector('[data-tdb-faq-accordion]');
    if (!source || !accordion || accordion.dataset.tdbFaqReady === 'true') return;

    var items = [];
    var currentItem = null;

    Array.prototype.slice.call(source.children).forEach(function (node) {
      var text = (node.textContent || '').trim();
      if (!text) return;

      if (text.slice(-1) === '?') {
        var details = document.createElement('details');
        var summary = document.createElement('summary');
        var answer = document.createElement('div');

        details.className = 'tdb-faq-card';
        answer.className = 'tdb-faq-card__answer';
        summary.textContent = text;
        details.appendChild(summary);
        details.appendChild(answer);

        currentItem = { details: details, answer: answer };
        items.push(currentItem);
        return;
      }

      if (currentItem) currentItem.answer.appendChild(node.cloneNode(true));
    });

    if (!items.length) {
      source.hidden = false;
      return;
    }

    items.forEach(function (item) {
      accordion.appendChild(item.details);
    });

    accordion.dataset.tdbFaqReady = 'true';
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFaqAccordion);
  } else {
    initFaqAccordion();
  }

  document.addEventListener('shopify:section:load', initFaqAccordion);
})();
